import { render, staticRenderFns } from "./AutoImportLog.vue?vue&type=template&id=13a70f88&scoped=true"
import script from "./AutoImportLog.vue?vue&type=script&lang=js"
export * from "./AutoImportLog.vue?vue&type=script&lang=js"
import style0 from "./AutoImportLog.vue?vue&type=style&index=0&id=13a70f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a70f88",
  null
  
)

export default component.exports